// extracted by mini-css-extract-plugin
module.exports = {"iconCol":"_203SxH","wrapper":"_10PmET","wrapperLocked":"_1xES-M","wrapperManage":"_3E4c1_","module":"_1Kw-Q9","noShadow":"_3Q2AbU"};